export const InputTypes = {
    SWITCH: 'SWITCH',
    FIELD: 'FIELD',
    FIELD_READONLY: 'FIELD_READONLY',
    HIDDEN_FIELD: 'HIDDEN_FIELD',
    SELECT: 'SELECT',
    DATE: 'DATE'
};
